import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./utils/AuthContext";
import routes from "./routes/routes";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {
            routes.map(
              ({path, element}, index) => (
                <Route key={index} path={path} element={element} />
              )
            )
          }
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
